(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/draw-list.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/draw-list.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.DrawList = Marionette.CollectionView.extend({
    className: 'draw-list',

    childView: svs.matchen.views.Draw
  });
})(Backbone, _, svs);


 })(window);